export default __webpack_public_path__ + "static/media/gamefi_04_1.87f50c66.png";